import useLocation from 'react-use/lib/useLocation'

// This custom hook returns value of given string from query param
export default function useDynamicSearchParam(
  paramName: string
): string | null {
  const { search } = useLocation()
  return new URLSearchParams(search?.substring(1) ?? '').get(paramName)
}
